// import {
//     initStatCounter,
// } from '@js/common/all-functions.js';

initStatCounter('.statistics-row-section .srs-col');

/* Stats Counter Start */
function initStatCounter(selecter) {
    window.addEventListener('DOMContentLoaded', handleCounters);
    window.addEventListener('scroll', handleCounters);
    window.addEventListener('resize', handleCounters);

    function handleCounters() {
        const cols = document.querySelectorAll(selecter);

        cols.forEach(col => {
            if (isPartiallyVisible(col)) {
                startCounters(col);
            }
        });
    }

    function startCounters(elem) {
        const sectionTop = elem.getBoundingClientRect().top + window.pageYOffset;
        const windowHeight = window.innerHeight;
        const counterAnimated = elem.dataset.counterAnimated === 'true';

        if (!counterAnimated && window.pageYOffset > sectionTop + 200 - windowHeight) {
            const counters = elem.querySelectorAll('.stat-counter');

            counters.forEach(counter => {
                if (!counter.classList.contains('counted')) {
                    const originalValue = counter.dataset.count.toString();
                    const cleanedValue = originalValue.replace(/,/g, '');
                    const finalValue = parseFloat(cleanedValue);

                    if (!isNaN(finalValue)) {
                        const duration = finalValue < 10 ? 800 : 1200;
                        counter.textContent = '0';

                        setTimeout(() => {
                            let start = null;

                            function animateCounter(timestamp) {
                                if (!start) {
                                    start = timestamp;
                                }
                                const progress = timestamp - start;
                                const step = Math.min(progress / duration, 1);
                                const current = finalValue * step;

                                const formatted = applyCustomFormat(
                                    originalValue,
                                    current.toFixed(getDecimalPlaces(originalValue)),
                                );
                                counter.textContent = formatted;

                                if (step < 1) {
                                    requestAnimationFrame(animateCounter);
                                } else {
                                    counter.textContent = originalValue;
                                    counter.classList.add('counted');
                                }
                            }

                            requestAnimationFrame(animateCounter);
                        }, 100);
                    }
                }
            });

            elem.dataset.counterAnimated = 'true';
        }
    }

    function getDecimalPlaces(number) {
        const parts = number.split('.');
        return parts.length > 1 ? parts[1].length : 0;
    }

    function applyCustomFormat(originalValue, currentNumber) {
        const originalParts = originalValue.split('.');
        const integerPart = originalParts[0];
        const decimalPart = originalParts[1] || '';

        const reversed = currentNumber.split('.')[0].split('').reverse();
        const formatted = [];
        let index = 0;

        const originalIntParts = integerPart.includes(',') ? integerPart.split(',') : [integerPart];
        for (let i = 0; i < originalIntParts.length; i++) {
            const partLength = originalIntParts[i].length;
            const part = reversed.slice(index, index + partLength).reverse().join('');
            formatted.push(part);
            index += partLength;
        }

        const formattedInt = formatted.join(',');
        const currentDecimal = currentNumber.split('.')[1] || '';

        return decimalPart ? `${formattedInt}.${currentDecimal}` : formattedInt;
    }

    function isPartiallyVisible(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const windowTop = 0;
        const windowBottom = windowHeight;

        const elementTop = rect.top;
        const elementBottom = rect.bottom;

        return elementBottom > windowTop && elementTop < windowBottom;
    }
};
/* Stats Counter End */